class PlayList {
  constructor(options = {}) {
    const { list = [], loop = false } = options;
    this.list = list;
    this.loop = loop;
    this.index = 0;
  }

  updateList(list) {
    if (list == null) {
      throw Error('playlist need list');
    }
    this.list = list;
  }

  updateIndex(value) {
    this.index = value;
  }

  getIndexById(id) {
    return this.list.findIndex(item => item.id === id);
  }

  getNextIndex() {
    const { index, list, loop } = this;
    const { length } = list;
    const next = index + 1;
    if (next === length) {
      if (loop) return 0;
      return -1;
    }
    return next;
  }

  getCurrentItem() {
    const { index } = this;
    return this.getItemByIndex(index);
  }

  getItemByIndex(index) {
    return this.list.find((item, i) => i === index);
  }
}

export default PlayList;
